<template>
  <div class="home">
    <div class="main">
      <div class="left">
        <div class="item">
          <el-image
              class="image"
              :src="src"
              @error="imgLoadError"
              fit="fit"></el-image>
          <el-button v-show="showButton" class="start-btn btn" @click.stop="_startRecord()">{{ $t('startDebugging') }}</el-button>
          <div class="number-box">
            <div class="hundred">{{hundred}}</div>
            <div class="Ten">{{ten}}</div>
            <div class="single">{{single}}</div>
          </div>
          <div v-show="!showButton" class="connecting">
            <div class="key">{{ $t("dynamicPassword") }}：
              <span v-for="number in (dynamicKey+'').split('')" :key="number + Math.random()" class="key-item">
                {{number}}
              </span>
            </div>
            <h1 class="name">{{ $t("waitingForConnection") }} ...</h1>
            <el-button class="btn" @click="cancelRecord">{{ $t("cancel") }}</el-button>
          </div>
        </div>
      </div>
      <div class="right">
        <el-form class="form" label-width="120px" :rules="loginRules" ref="loginForm" :model="searchForm">
          <el-form-item :label="$t('agencyName')" prop="distributorName" class="form-item">
            <el-input v-model="searchForm.distributorName" disabled class="form-item-input"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fieldStaffName')" prop="sitePerson" class="form-item">
            <el-input v-model="searchForm.sitePerson" class="form-item-input"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fieldStaffPhone')" prop="sitePersonPhone" class="form-item">
            <el-input v-model="searchForm.sitePersonPhone" class="form-item-input"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fieldStaffJob')" prop="sitePersonDuty" class="form-item">
            <el-input v-model="searchForm.sitePersonDuty" class="form-item-input"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import beginConnect from '../../assets/img/home/beginConnect.png'
import connecting from '../../assets/img/home/connecting.png'
import connectingWait from '../../assets/img/home/connecting-waiting.png'
import { startRecord, cancelRecord } from "@/api/record"
import { getModelFeature } from "@/api/remote";
// eslint-disable-next-line no-unused-vars
import {timediff, stampToDateTime} from "assets/utils"
export default {
  name: "home",
  // props: ['tid'],
  data() {
    return {
      beginConnect,
      connectingWait,
      collapse: false,
      firstActiveName: 'management',
      secondActiveName: 'management-commission',
      menuList: [],
      searchForm: {
        agencyName:"",
        sitePerson: '',
        sitePersonPhone: '',
        sitePersonDuty: '',
        distributorName: this.$store.state.userInfo.distributorName,
        userName: ''
      },
      loginRules: {
          sitePerson: [
            { required: true, message: '请输入现场人员姓名', trigger: 'blur' }
          ],
          sitePersonPhone: [
            { required: true, message: '请输入现场人员手机号', trigger: 'blur' }
          ]
      },
      src: '',
      showButton: true,
      dynamicKey: '1234567890',
      hundred: '',
      ten: '',
      single: '',
      tid: "",
      recordId: "",
      getImgIndex:0,
    }
  },
  computed: {
    formData(){
      return this.$store.state.formData
    },
    tidType(){
      return this.$store.state.tidType
    },
    username() {
      return this.$store.state.userInfo.name
    },
    debugSeconds () {
      return this.$store.state.debugSeconds
    },
    debugStatus () {
      return this.$store.state.debugStatus
    },
    debugFlag () {
      return this.$store.state.debugFlag
    },
    controlInfo () {
      return this.$store.state.controlInfo
    },
    sysSetting() {
      return this.$store.state.sysSetting
    },
    debugKey(){
      return this.$store.state.debugKey
    },
  },
  mounted() {
    this.src = connectingWait
    console.log("开始调试点击")
    this.page_init();
  },
  watch: {
    tid(newval) {
      console.log(newval,"tid")
      this.dealTidPage(newval)
    },
    async debugFlag(newval){
      console.log(newval,'debugFlag发生变化')
      // 监听到已连接设备，则跳转相应的页面，恢复初始值
      if (newval) {
        // 获取控制器权限
        let auth = await this.getControlAuth(this.controlInfo.model);
        sessionStorage.controlAuth = JSON.stringify(auth);
        this.$store.commit("setControlAuth", auth);
        clearInterval(this.timer)
        this.dealCountDownData(this.debugSeconds)
        this.showButton = true;
        let formData = JSON.parse(sessionStorage.formData)
        let sysSetting = Object.assign({},this.controlInfo, formData)
        this.$store.commit('setSysSetting', sysSetting);
        sessionStorage.sysSetting = JSON.stringify(sysSetting)
        // this.$emit("changeRouter") // 跳转上层判断有权限的路由跳转第一个
        this.$router.replace('/monitor/monitor'); // 跳转上层无条件跳转监控模块
        this.$emit("enable", newval)
      }
    }
  },
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    page_init(){
      this.searchForm = this.$store.state.formData;
      if (this.debugStatus === 1) {
        // 开始调试界面
      } else if (this.debugStatus === 2) {
        // 等待调试界面
        console.log(this.debugStatus === 2,"this.debugStatus === 2")
        this.src = connectingWait;
        this.tid = this.debugSeconds
      } else if (this.debugStatus === 3) {
        // 调试结束
      }
    },
    //  处理倒计时数据
    dealCountDownData(seconds){
      if (seconds === 0 || seconds === '' || seconds < 0) {
        if (this.timer) {
          clearInterval(this.timer)
        }
        console.log("seconds:",seconds)
        this.$store.commit("changeDebugSeconds",0);
        sessionStorage.debugSeconds = 0;
        this.single = "";
        this.ten = "";
        this.hundred = ""
        this.$store.commit("changeDebugStatus",1);
        sessionStorage.debugStatus = 1;
        return
      }
      this.$store.commit("changeDebugSeconds",seconds);
      sessionStorage.debugSeconds = seconds;
      this.single = this.getSepNum(seconds).single
      this.ten = this.getSepNum(seconds).ten
      this.hundred = this.getSepNum(seconds).hundred
    },
    imgLoadError(err){
      if (this.getImgIndex >= 3) {
        return
      }
      console.log(err)
      this.src = ""
      setTimeout(() => {
        this.src = this.debugStatus === 2 ? connectingWait : connecting;
        this.getImgIndex++
      })
    },
    dealTidPage(newval){
      // debugger
      // tid 为1或2 为正常跳转 不带时间戳数据 不做处理
      if (Number(newval) === 1 || Number(newval) === 2 || !newval) return
      console.log(newval,"tid")
      // 获取调试错误信息
      let debugData = JSON.parse(sessionStorage.DebugData || "{}")
      this.dynamicKey = this.debugKey;
      let dynamicKeyExpir = Number(newval)
      let timestamp = Math.floor(new Date().getTime() / 1000);
      let seconds = this.tidType === 'timeStamp' ? parseInt(dynamicKeyExpir - timestamp) : newval
      this.dealCountDownData(seconds)
      if (this.tidType === 'timeStamp') {
        this.$store.commit("changeTidType","secondes");
        sessionStorage.tidType = "secondes";
      }
      this.src = connectingWait;
      this.showButton = false
      // 清空 bwait
      delete debugData.bwait
      this.$store.commit('setDebugData', debugData);
      sessionStorage.DebugData = JSON.stringify(debugData)
      // 将调试人员信息回显
      this.searchForm = this.$store.state.formData;
      // 开始倒计时
      this.timer = setInterval(() => {
        seconds--
        this.dealCountDownData(seconds)
        if (seconds === 0) {
          clearInterval(this.timer)
          this.showButton = true
          this.dealCountDownData(seconds)
          cancelRecord({id:this.sysSetting.recordId}).then(res => {
                  console.log(res)
          }).catch(err => {
              this.$message.error(err.msg)
          })
        }
      }, 1000)
    },
    dealAuth(auth){
      let userAuth = this.$store.state.userInfo.authorities;
      let controlAuth = auth;
      return userAuth && controlAuth
    },
    /**
     * @description: 获取控制器权限信息
     * @param: code: 控制器psn
     */
    getControlAuth(code){
      return getModelFeature({code: code}).then(res => {
        return res.data
      })
    },
    /**
     * @params number: second 秒
     * @description 处理倒计时时分秒工具函数
     */
    getSepNum(number){
      return {
        hundred: Math.floor(number / 100),
        ten: Math.floor(number % 100 / 10),
        single: Math.floor(number % 100 % 10),
      }
    },
    // name: homeShow  sideBarActive:  debugFlag  isMonitor
    // value
    _startRecord(event) {
      console.log(this.$refs.loginForm.validate(),"121")
      this.$refs.loginForm.validate().then(() => {
        this.searchForm.userName = this.username
        startRecord({...this.searchForm}).then((res) => {
          // 先开始调试，然后给你这个返回值，你显示的倒计时是用这个返回值计算出来的
          if (res.code === 1){
            this.$store.commit("changeDebugStatus",2);
            sessionStorage.debugStatus = 2;
            this.$store.commit("changeTidType","secondes");
            sessionStorage.tidType = "secondes";
            // 存储调试人员信息
            this.recordId = res.data.recordId;
            this.searchForm.recordId = res.data.recordId
            this.$store.commit('setFormData',this.searchForm);
            sessionStorage.formData = JSON.stringify(this.searchForm);
            // 计算两个时间戳相差的描述
            console.log(new Date(stampToDateTime(res.data.dynamicKeyExpir)))
            this.dynamicKey = res.data.dynamicKey
            this.$store.commit("setDebugKey",this.dynamicKey)
            sessionStorage.debugKey = this.dynamicKey;
            let timestamp = Math.floor(new Date().getTime() / 1000);
            let seconds = parseInt(res.data.dynamicKeyExpir - timestamp)
              // seconds = 5
            this.dealCountDownData(seconds)
            this.src = connectingWait
              // let _this = this
            this.showButton = false
            this.timer = setInterval(() => {
              seconds--
              this.dealCountDownData(seconds)
              if (seconds === 0) {
                clearInterval(this.timer)
                this.showButton = true;
                this.dealCountDownData(seconds)
                // this.$store.commit('changeDebugFlag', true); // 倒计时结束 暂时算通过
                // localStorage.setItem('debugFlag', true)
                // let sysSetting = Object.assign({},this.controlInfo, this.searchForm)
                // this.$store.commit('setSysSetting', sysSetting);
                // sessionStorage.sysSetting = JSON.stringify(sysSetting)
                // this.$emit("enable", this.debugFlag)
                // this.$router.replace('/connect')
                cancelRecord({id:res.data.recordId}).then(res => {
                  console.log(res)
                  this.$store.commit("changeDebugStatus",1);
                  sessionStorage.debugStatus = 1;
                }).catch(err => {
                  this.$message.error(err.msg)
                })
              }
            }, 1000)
          }
        })
      })
    },
    cancelRecord(){
      cancelRecord({id:this.recordId ? this.recordId : this.formData.recordId}).then(res => {
        console.log(res)
        if (res.code === 1) {
          this.$message.success(res.message);
          clearInterval(this.timer)
          this.showButton = true;
          let seconds = "";
          this.dealCountDownData(seconds)
          this.$store.commit("changeDebugStatus",1);
          sessionStorage.debugStatus = 1;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background-color: #fff;
  width: 100%;
  height: 100%;
  .main {
    width: 100%;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .left {
      float: left;
      margin-right: 160px;
      position: relative;
      .item {
        .image {
          width: 540px;
          height: 385px;
          display: block;
        }
        .start-btn{
          margin-top: 60px;
        }
        .connecting{
          margin-top: 60px;
          .name{
            color: #F05241;
          }
          h1{
            font-size: 16px;
          }
          .btn{
            cursor: pointer;
            padding: 4px 8px;
            border-radius: 4px;
          }
          .key{
            font-size: 16px;
            .key-item{
              display: inline-block;
              width: 34px;
              height: 34px;
              text-align: center;
              line-height: 34px;
              background: #26BBEC;
              border: 2px solid #2F4E68;
              border-radius: 4px;
              margin-left: 5px;
              color: #fff;
            }
          }
        }
        .number-box{
          position: absolute;
          top: 3.6%;
          left: 19%;
          color: #000;
          .hundred {
            font-size: 30px;
            float: left;
          }
        .Ten {
          font-size: 30px;
          float: left;
          margin-left: 38px;
        }
        .single {
          font-size: 30px;
          float: left;
          margin-left: 38px;
        }
        }
        .btn {
          width: 200px;
          height: 48px;
          background-color: #39B66E;
          border-radius: 12px;
          color: #ffffff;
          font-size: 16px;
        }
      }
    }

    .right {
      float: left;
      // margin-top: 50px;

      .form {
        text-align: center;
        .el-form-item {
          width: 320px;
          text-align: center;
          margin: auto;
          padding: 5px;
          margin-bottom: 20px;
          &:nth-child(3) {
            padding-bottom: 10px;
          }

          .el-form-item--mini .el-form-item__content {
            width: 130px;
            margin-left: 90px !important;
          }

          .el-input-number--mini {
            width: 210px;
          }
        }

        .el-input-number.is-without-controls .el-input__inner {
          width: 100px;
          line-height: 30px;
          height: 28px;
        }

      }
    }
  }
}
</style>
<style lang="scss">
.home {
  .right {
    .form {
      .form-item{
        .form-item-input{
          .el-input__inner{
            background: #EFF3F9;
          }
        }
        }
    }
  }
}
</style>
